import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    testRunDetail,
    testRunState,
} from '../../../../redux/testRun/testRunList.slice'
import ChartStatus from './ChartStatus'
import ReportStats from './ReportStats'
import SkeletonReportSection from './SkeletonReportSection'
import styles from '../../../../testrun.module.css'

const TestRunReport = ({ reportId }) => {
    const dispatch = useDispatch()
    const {
        testRunDetail: testRunDetailData,
        testRunDetailLoading,
        fetchReportToggle,
    } = useSelector(testRunState)

    useEffect(() => {
        dispatch(testRunDetail(reportId))
    }, [dispatch, fetchReportToggle, reportId])

    if (testRunDetailLoading) return <SkeletonReportSection />

    return (
        <div className={styles.reportChartCard}>
            <div className={styles.reportChartInner}>
                <div className={styles.reportChartCol}>
                    <ChartStatus data={testRunDetailData} />
                </div>
                <div className={styles.reportStatsCol}>
                    <ReportStats
                        data={testRunDetailData?.statusSummary || []}
                    />
                </div>
            </div>
        </div>
    )
}

export default TestRunReport
